import PropTypes from 'prop-types';
import React from 'react';
import { Link as LinkGatsby } from 'gatsby';
import { Link as LinkIntl } from 'gatsby-plugin-intl';

const ConditionalLink = ({
  condition, link, local, children, ...props
}) => (
  condition ? (
    local ? (
      <LinkGatsby to={link} {...props} style={{ width: '100%' }}>{children}</LinkGatsby>
    ) : (
      <LinkIntl to={link} {...props} style={{ width: '100%' }}>{children}</LinkIntl>
    )
  ) : (
    <div {...props} style={{ width: '100%' }}>
      {children}
    </div>
  )
);

ConditionalLink.propTypes = {
  condition: PropTypes.bool,
  link: PropTypes.any,
  local: PropTypes.bool,
  children: PropTypes.any.isRequired,
};

ConditionalLink.defaultProps = {
  condition: false,
  link: null,
  local: false,
};

export default ConditionalLink;
